// @flow
import React from 'react';
import { Link } from 'react-router-dom';
import './BrandActionButtons.scss';

type Props = {
  id: string,
  onAskRemove: () => void,
};

const BrandActionButtons = ({ id, onAskRemove }: Props) => (
  <div className="BrandActionButtons">
    <Link to={`/write?edit_id=${id}&type=brand`} className="btn">
      수정
    </Link>
    <button className="btn" onClick={onAskRemove}>
      삭제
    </button>
  </div>
);

export default BrandActionButtons;



// WEBPACK FOOTER //
// ./src/components/brand/BrandActionButtons/BrandActionButtons.js